import type React from 'react';

import type { IconProps } from 'types/icon';

const Gphc: React.FC<IconProps> = ({
  size = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M18.0895 8.49187C18.0895 7.63242 17.3919 6.93587 16.5318 6.93587C15.6716 6.93588 14.9745 7.63242 14.9745 8.49187C14.9745 9.35133 15.6716 10.0483 16.5318 10.0483C17.3919 10.0483 18.0895 9.35134 18.0895 8.49187ZM18.9996 8.49187C18.9996 9.85358 17.8946 10.9576 16.5318 10.9576C15.1689 10.9576 14.064 9.85357 14.064 8.49187C14.064 7.13018 15.1689 6.02613 16.5318 6.02612C17.8946 6.02612 18.9996 7.13018 18.9996 8.49187Z"
        fill={color}
      />
      <path
        d="M16.5318 8.99562C16.8103 8.99562 17.036 8.77006 17.036 8.49183C17.036 8.21359 16.8103 7.98804 16.5318 7.98804C16.2533 7.98804 16.0276 8.21359 16.0276 8.49183C16.0276 8.77006 16.2533 8.99562 16.5318 8.99562Z"
        fill={color}
      />
      <path
        d="M6.46062 13.0218C7.29602 13.0218 7.97325 12.3451 7.97325 11.5104C7.97325 10.6757 7.29602 9.99902 6.46062 9.99902C5.62522 9.99902 4.948 10.6757 4.948 11.5104C4.948 12.3451 5.62522 13.0218 6.46062 13.0218Z"
        fill={color}
      />
      <path
        d="M10.4896 2C11.2879 2 11.9698 2.65032 11.9184 3.48595L11.918 3.48762C11.8135 5.10727 11.461 7.18469 10.6532 8.87316C9.84557 10.5613 8.52334 11.9651 6.46038 11.9651C6.20905 11.9651 6.00513 11.7614 6.00513 11.5103C6.00514 11.2592 6.20906 11.0554 6.46038 11.0554C8.01661 11.0554 9.09391 10.0236 9.83201 8.48083C10.5699 6.93852 10.9093 4.98983 11.01 3.42883C11.026 3.15508 10.8018 2.90975 10.4896 2.90975H9.48149C9.23016 2.90975 9.02624 2.70599 9.02624 2.45488C9.02624 2.20376 9.23016 2 9.48149 2H10.4896Z"
        fill={color}
      />
      <path
        d="M3.43965 2C3.69092 2.00006 3.89448 2.2038 3.89448 2.45488C3.89448 2.70595 3.69092 2.90969 3.43965 2.90975H2.43108C2.11862 2.90977 1.89461 3.15558 1.91115 3.42967L1.93243 3.72611C2.0536 5.22988 2.39522 7.03277 3.08746 8.47916C3.82611 10.0225 4.90424 11.0553 6.46034 11.0554C6.71166 11.0554 6.91559 11.2592 6.91559 11.5103C6.91559 11.7614 6.71167 11.9651 6.46034 11.9651C4.39743 11.9651 3.07437 10.56 2.26625 8.87149C1.45786 7.18239 1.10503 5.10483 1.00273 3.48679V3.48595C0.951352 2.65033 1.63287 2.00002 2.43108 2H3.43965Z"
        fill={color}
      />
      <path
        d="M6.00098 12.5136V11.5059C6.00107 11.2548 6.20496 11.0514 6.45623 11.0514C6.7075 11.0514 6.91139 11.2548 6.91148 11.5059V12.5136C6.91148 15.0419 8.96369 17.0924 11.4941 17.0924C14.0244 17.0924 16.0766 15.0419 16.0766 12.5136V10.5027C16.0766 10.2516 16.2806 10.0479 16.5319 10.0479C16.7832 10.0479 16.9867 10.2516 16.9867 10.5027V12.5136C16.9867 15.5441 14.5271 18.0021 11.4941 18.0021C8.46104 18.0021 6.00098 15.5441 6.00098 12.5136Z"
        fill={color}
      />
    </svg>
  );
};

export default Gphc;
